module.exports = __webpack_public_path__ + "media/adthos_audio_watermark.24fbb352.mp3";